import useSWR from 'hooks/useSWR';
import { useSWRResource } from 'util/resource/useSWRResource';
import { CompanyUpdate } from 'types/content';
import { companyUpdateAPI } from './UpdateAPI';
import { useCompanyProfileById } from 'apis/CompanyAPI/companies/useCompanyProfile';

export function useCompanyUpdate(companyId: number, updateId: UUID) {
  const api = companyUpdateAPI(companyId);
  const swrResult = useSWR<CompanyUpdate>(api.get(updateId));

  // Fetch company profile if update is loaded
  useCompanyProfileById(swrResult.data?.companyId);

  return useSWRResource(swrResult);
}
